module.exports = "/static/assets/1920e91b54ab5d267aa2b9b0a5288c3c.png";